import { render } from "./TDBG_SRSQ.vue?vue&type=template&id=3175977c&scoped=true"
import script from "./TDBG_SRSQ.vue?vue&type=script&lang=js"
export * from "./TDBG_SRSQ.vue?vue&type=script&lang=js"

import "./TDBG_SRSQ.vue?vue&type=style&index=0&id=3175977c&scoped=scoped&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3175977c"]])

export default __exports__